<template>
    <div class="bg-white shadow-lg rounded-sm border border-gray-200 mb-8">
        <div class="flex flex-row">
            <div class="flex flex-nowrap px-5 py-10">
                <div class="pl-5 pr-10">
                    <div class="sticky top-24">
                        <div class="font-bold mb-3 text-gray-900">Question Categories</div>
                        <div class="flex flex-col justify-between pb-5">
                            <ul
                                class="flex flex-col flex-nowrap"
                                v-for="(group, gIndex) in faqs.groups"
                                :key="'group-' + gIndex"
                            >
                                <li class="mb-1 mr-0">
                                    <a
                                        class="
                                            flex
                                            items-center
                                            px-2.5
                                            py-2
                                            rounded
                                            whitespace-nowrap
                                            hover:text-orange
                                        "
                                        :href="'#' + group.slug"
                                    >
                                        <span class="text-sm font-medium">{{ group.title }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="border-l border-gray-200" style="flex-grow: 1">
                <div class="flex flex-nowrap flex-col items-center px-10 py-10">
                
				    <div class="mb-20 pb-8 border-b border-gray-200 last:border-b-0 prose mx-auto w-full text-center">
				      <h1>
				        <span class="mt-2 block text-center text-3xl font-bold leading-8 tracking-tight text-gray-900">Frequently Asked Questions</span>
				      </h1>
				      <p class="mt-8 text-base leading-8 text-gray-500">Here are answers to questions frequently asked by My10x users.</p>
				      <p class="mt-8 text-base leading-8 text-gray-500">Have a different question and can’t find the answer you’re looking for? Reach out to our <a href="/support/" target="_blank" class="text-orange hover:text-orange-400">support team</a> and we’ll get back to you as soon as we can.</p>
				    </div>                

                    <div
                        :id="group.slug"
                        v-for="(group, gIndex) in faqs.groups"
                        :key="'group-' + gIndex"
                        class="mb-20 pb-8 border-b border-gray-200 last:border-b-0 prose mx-auto w-full"
                        style="scroll-margin: 100px"
                    >
                        <h4 class="text-2xl leading-snug text-gray-800 font-bold mb-5" id="group1">
                            {{ group.title }}
                        </h4>

                        <dl
                            class="
                                space-y-10
                                lg:grid lg:grid-cols-1
                                lg:gap-x-8 lg:gap-y-8
                                lg:space-y-0
                            "
                        >
                            <div v-for="(question, qIndex) in group.questions" :key="'q-' + qIndex">
                                <!--<dt class="font-semibold text-gray-900 prose">
                                    <div v-html="question.question"></div>
                                </dt>
                                <dd class="mt-3 text-gray-500 prose">
                                    <div v-html="question.answer"></div>
                                </dd>-->
                                
								<details class="group">
									<summary class="flex cursor-pointer list-none items-center justify-between font-semibold text-gray-900 prose">
										<span v-html="question.question"></span>
										<span class="transition group-open:rotate-180">
											<svg fill="none" height="24" shape-rendering="geometricPrecision" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" width="24"><path d="M6 9l6 6 6-6"></path></svg>
										</span>
									</summary>
									<div class="group-open:animate-fadeIn mt-3 text-gray-500 prose" v-html="question.answer"></div>
								</details>                                
                                
                                
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        faqs: {
            groups: [
                {
                    title: 'General Questions',
                    show: false,
                    slug: 'general-questions',
                    questions: [
                        {
                            question: 'How can I change my email address for my account?',
                            answer: 'Currently you are unable to change the email address associated with your My10x account and must use the email address with which you signed up for your account.',
                            show: false,
                        },
                        {
                            question: 'How can I reset my password?',
                            answer: '<p>If you\'re not logged in, you can simply go to the <a href="https://my.10xtravel.com/login" target="_blank" class="text-orange hover:text-orange-400">login page</a> and click "Forgot Password".</p><p>If you\'re logged in, you can simply go to your <a href="https://my.10xtravel.com/settings" target="_blank" class="text-orange hover:text-orange-400">Account Settings</a> page, and change your password there.</p>',
                            show: false,
                        },

                        {
                            question: 'How can I best secure my My10x account?',
                            answer: 'When you originally registered for My10x (if you didn\'t utilize a Single Sign On option), we already required you to utilize a strong password. After that, the best way to secure your My10x account when not using Single Sign On is to enable Two-Factor Authentication (2FA) on your <a href="https://my.10xtravel.com/settings" target="_blank" class="text-orange hover:text-orange-400">Account Settings</a> page.</p> <p>With 2FA enabled, every time you login, we\'ll send you a random 6-digit code via SMS to help verify your account authentication. ',
                            show: false,
                        },

                        {
                            question: 'How can I know that my My10x data is secure?',
                            answer: '<p>We take as many measures as possible in order to protect your information from unauthorized access as best as possible using the most up to date security measures and best practices.</p> <p>More on our <a href="/security/" class="text-orange hover:text-orange-400">Security Practices can be found here</a>.',
                            show: false,
                        },
                    ],
                },

                {
                    title: 'Connected Accounts',
                    show: false,
                    slug: 'connected-accounts',
                    questions: [
                        {
                            question: 'How many credit cards can I sync?',
                            answer: 'There are no limitations to the number of cards or account connections that you can sync.',
                        },
                        {
                            question:
                                'I have multiple logins at the same institution. Are there any limitations with multiple accounts within the same institution?',
                            answer: "No - we've developed our account connection workflow to support multiple account connections at the same institution for each My10x user.",
                        },

                        {
                            question: 'How often are my points balances updated?',
                            answer: 'Connected credit card accounts are updated every 24 hours at 4am ET.',
                        },

                        {
                            question:
                                'My connected account in My10x is showing a different rewards balance than in my institution rewards account. ',
                            answer: "Since points are synced once every 24 hours, your My10x rewards balance won't update in real time and there can be a bit of a lag. However, if it's been more than 4 or 5 days and your balance still isn't reflecting the correct balance, please reach out.",
                        },
                        {
                            question: 'How can I see and manage all of my institution connections?',
                            answer: 'From <a href="https://my.10xtravel.com/wallet" target="_blank" class="text-orange hover:text-orange-400">My Wallet</a>, click <a href="/wallet/members" target="_blank" class="text-orange hover:text-orange-400">Manage Connections</a> to see a list of all of the different institution connections that you have, and also which user they are associated with. From this page you can also remove select connections, but be warned - this will remove all of the data instantly from My10x and it isn\'t recoverable.',
                        },
						{                        
                        
							question:
                                'How do I remove an authorized user\'s card from My Wallet that was automatically imported from an institution connection? ',
                            answer: 'In <a href="https://my.10xtravel.com/wallet" target="_blank" class="text-orange hover:text-orange-400">My Wallet</a>, click the <span class="rounded-full bg-gray-100 w-8 h-8 inline-flex items-center justify-center outline-none"><i class="far fa-ellipsis-h text-lg text-gray-400"></i></span> icon at the end of the selected row. From that menu, select "Edit" to bring up the edit card window.<ul><li>If you haven\'t matched your card yet, in this window, simply select "This is not a Credit Card" to hide this from your account.</li><li>If your card has already been previously matched, select "Not the right card? Change Here" to change the card. From the now displayed change card area, simply select "This is not a Credit Card" to hide this from your account.</li></ul>',         
                        }               
                        
                    ],
                },

                {
                    title: 'Manual Accounts',
                    show: false,
                    slug: 'manual-accounts',
                    questions: [
                        {
                            question:"I'm not comfortable connecting to my institution through My10x. Will the My10x experience be any different for me because of that?",
                            answer: "<p>While our institution connection setup follows industry standards and best practices in terms of privacy, encryption, and authentication, we completely understand that some users may still not be comfortable going down this path.</p> <p>Because of this, we designed My10x to work almost seamlessly for both types of users.</p><p>In short, no - your experience won't be much different should you choose to manually manage your credit cards and loyalty program balances instead of connecting directly to institutions. However, you will have to manually track and update your loyalty program balances from time to time (don't worry - we'll prompt you to do this every once and awhile with reminders!). You'll also have a few more manual steps on the initial setup workflow by adding your cards one by one to your wallet. After that, that's pretty much the only difference!</p>",
                            show: false,
                        },
                        {
                            question:
                                'How do I remove a manually added card from My Wallet? ',
                            answer: 'In <a href="https://my.10xtravel.com/wallet" target="_blank" class="text-orange hover:text-orange-400">My Wallet</a>, click the <span class="rounded-full bg-gray-100 w-8 h-8 inline-flex items-center justify-center outline-none"><i class="far fa-ellipsis-h text-lg text-gray-400"></i></span> icon at the end of the selected row. From that menu, select "Remove", then confirm that yes, you wish to remove this card. Then the card will be removed and the data deleted for that card.',
                        },
                        
                    ],
                },
                {
                    title: 'Additional Users',
                    show: false,
                    slug: 'additional-users',
                    questions: [
                        {
                            question:
                                'Why do I have to give the email address of each user I want to add to my account?',
                            answer: '<p>We require permission from all users who wish to link their accounts in My10x. Collecting the email address of each member and registering their account initially allows each person to grant this permission or revoke it at any time.</p>',
                            show: false,
                        },
                    ],
                },

                {
                    title: 'My Wallet',
                    show: false,
                    slug: 'my-wallet',
                    questions: [
						{                        
							question:
                                'I accidentally matched to the wrong card. How do I change which card I matched to? ',
                            answer: 'In <a href="https://my.10xtravel.com/wallet" target="_blank" class="text-orange hover:text-orange-400">My Wallet</a>, click the <span class="rounded-full bg-gray-100 w-8 h-8 inline-flex items-center justify-center outline-none"><i class="far fa-ellipsis-h text-lg text-gray-400"></i></span> icon at the end of the selected row. From that menu, select "Edit" to bring up the edit card window. In this window, simply select the correct card from the dropdown match this card to the correct card.',         
                        }, 
						{                        
							question:
                                'My card is not listed when I try and match my card.',
                            answer: 'If you are unable to find your exact card in our existing card database, simply select the checkbox for "My card is not listed", and follow the steps to submit a Missing Card Request. Once we have added this card to our database, you will be notified and your card will have been successfully matched to this card.',         
                        }                        
                    ],
                },

                {
                    title: 'My Points',
                    show: false,
                    slug: 'my-points',
                    questions: [
                        {
                            question: 'My points balance in My10x is not correct. What gives?',
                            answer: '<p>Your points balances for connected accounts update once every 24 hours and rely on the information provided by your connected financial institution, which is often not updated in real-time. For this reason, recent activity can take some time to be reflected in your My10x account.</p><p>For example, your Southwest Rapid Rewards balance will only update once monthly in your Chase account. Which will delay My10x\'s ability to show the most up-to-date balance in the My Points section of your account</p>',
                            show: false,
                        },
                    ],
                },
                {
                    title: 'My Next Card',
                    show: false,
                    slug: 'my-next-card',
                    questions: [
                        {
                            question: 'How does My Next Card Work?',
                            answer: '<p>My Next Card looks at your current credit cards, points balances, credit score, and other factors to recommend the best credit cards for you and you alone.</p><p>These recommendations are driven by the above factors as well as our own analysis of the best credit card offers on the market. We rank these offers by looking at a card\'s signup bonus, spending rewards, benefits, and annual fee to determine which cards will offer more value to the average person.</p><p>Of course everyone\'s circumstances are a little bit different, so we encourage you to compare multiple credit card offers to be sure that you are making the right choice.</p>',
                            show: false,
                        },
                        {
                            question:
                                'Why do I not see some cards as options for me in My Next Card?',
                            answer: "<p>The algorithm that powers My Next Card uses a variety of factors to present the best next card options for you. If you don't see a product that you're expecting to see, you're likely not eligible for it based on certain criteria.</p><p>To see all cards, even the ones that are hidden because you aren't eligible for them, toggle the 'Show Hidden Cards' filter in the My Next Card sidebar to include these in the results.</p>",
                            show: false,
                        },
                    ],
                },
                {
                    title: 'My Credit Score',
                    show: false,
                    slug: 'my-credit-score',
                    questions: [
                        {
                            question: 'Why do I have to provide my FICO score?',
                            answer: '<p>We ask that you provide your FICO credit score so that My10x can help you build and maintain a good credit score as well as only recommend credit products that you are likely to be approved for. You are not required to provide your credit score to utilize My10x, but doing so will help you get even more value out of this tool.</p>',
                            show: false,
                        },
                        {
                            question: 'Will my Credit Karma score work?',
                            answer: '<p>Credit Karma and other "FAKO" score sources (such as free credit scores given by your bank) are often inaccurate and therefore cannot be relied upon to accurately reflect your credit.</p><p>We strongly encourage you to use <a href="https://www.experian.com/consumer-products/score-boost.html" target="_blank" class="text-orange hover:text-orange-400">Experian Boost</a> to check and update your credit score in My10x. Experian Boost is free for everyone and will show you your real FICO credit score.',
                            show: false,
                        },
                        {
                            question: 'How often should I update my Credit Score?',
                            answer: "We recommend checking your score monthly, but quarterly at a minimum. We'll send you automated notifications from My10x reminding you to update your score if it's been too long.",
                            show: false,
                        },
                    ],
                },
            ],
        },
    }),
    methods: {
        scrollToTargetAdjusted(id) {
            const element = document.getElementById(id);
            const offset = 100;
            const bodyRect = document.getElementById('f-body').getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;
            console.log(offsetPosition);
            document.getElementById('f-body').scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        },
    },
    mounted() {
        if (window.location.hash) {
            this.scrollToTargetAdjusted(window.location.hash.substring(1));
        }
    },
};
</script>